import { render } from "./Logo.vue?vue&type=template&id=5abc1932&scoped=true"
import script from "./Logo.vue?vue&type=script&lang=js"
export * from "./Logo.vue?vue&type=script&lang=js"

import "./Logo.vue?vue&type=style&index=0&id=5abc1932&scoped=true&lang=css"

import exportComponent from "/var/www/html/smartbooking/smartbooking-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5abc1932"]])

export default __exports__